import { render, staticRenderFns } from "./Error404WithCustomMessage.vue?vue&type=template&id=331326f2"
import script from "./Error404WithCustomMessage.vue?vue&type=script&lang=js"
export * from "./Error404WithCustomMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports